import { render, staticRenderFns } from "./AddFamilyMember.vue?vue&type=template&id=63d56786&scoped=true&"
import script from "./AddFamilyMember.vue?vue&type=script&lang=js&"
export * from "./AddFamilyMember.vue?vue&type=script&lang=js&"
import style0 from "./AddFamilyMember.vue?vue&type=style&index=0&id=63d56786&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d56786",
  null
  
)

export default component.exports